import React, { PureComponent } from 'react';
import { pagesApi } from '../../apis/PagesApi';
import IconPlayYt from '../../assets/icons/IconPlayYt';
import { common } from '../../utils/common';
import VideoItem from './VideoItem';

class VideoPage extends PureComponent {
   state = {
      data: [],
   }
   _mouted = false;
   pageRef = null;
   abortController = null;

   setPageRef = (r) => {
      this.pageRef = r;
   }

   componentWillUnmount() {
      this._mouted = false;
      if (this.abortController) {
         this.abortController.abort();
      }
   }

   componentDidMount() {
      this._mouted = true;
      this.abortController = new window.AbortController();
      this.loadData();
   }

   componentDidUpdate(prevProps, prevState) {
      if (prevProps.name !== this.props.name) {
         this.loadData();
      }
   }

   setContainerHeight = () => {
      if (!this.props.name && this.pageRef) {
         this.props.setContainerHeight(this.pageRef.getBoundingClientRect().height);
      }
   }

   loadData = async () => {
      const { pageNo, pageSize, sort } = this.props;
      if (pageNo === null || pageNo === void 0 || pageNo < 0) {
         if (this.props.setPageNumber) {
            this.props.setPageNumber(this.props.name, null);
         }
         return;
      }
      const requestBody = {
         start: pageNo * pageSize,
         limit: pageSize,
         sort: sort,
      };
      if (this._mouted) {
         const responseList = await pagesApi.getVideoList(requestBody, this.abortController);
         // console.log(responseList);
         if (responseList && this._mouted) {
            await this.setState({
               data: responseList,
            });
            this.setContainerHeight();
            if (this.props.setPageNumber) {
               if (responseList.length !== 0) {
                  this.props.setPageNumber(this.props.name, pageNo);
               } else {
                  this.props.setPageNumber(this.props.name, null);
               }
            }
         } else {
            if (this.props.setPageNumber) {
               this.props.setPageNumber(this.props.name, null);
            }
         }
      }
   }

   render() {
      if (this.state.data.length !== 0) {
         return (
            <div className={`outline-box  ${this.props.name}`} ref={this.setPageRef}>
               <div className={`thumbnail-container`}>
                  {
                     this.state.data.map((item) => {
                        return (
                           <div className="thumbnail-item animate__animated animate__zoomIn" key={item.id}>
                              <div className="preview-video-thumb">
                                 {
                                    item.url &&
                                    <VideoItem url={item.url} />
                                 }
                              </div>
                           </div>
                        )
                     })
                  }
                  {
                     (this.state.data.length < this.props.pageSize) &&
                     Array.from({ length: this.props.pageSize - this.state.data.length }, (x, i) => i).map((fakeItem) => (
                        <div className="thumbnail-item blank" key={fakeItem} />
                     ))
                  }
               </div>
            </div>
         );
      }
      return null;
   }
}

export default VideoPage;